import mixitup from 'mixitup';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const blogGridSection = {
    init: function () {
        const sections = document.querySelectorAll('[data-blog-grid-section-js]');

        if (!sections.length) return;

        sections.forEach((section) => {
            let blogGridWrap = section.querySelector('.blog-grid');

            const mixer = mixitup(section, {
                animation: {
                    enable: false,
                    effects: 'fade',
                    duration: 800,
                },
                callbacks: {
                    onMixStart: () => {
                        blogGridWrap.classList.remove('activeAnim');
                    },
                    onMixEnd: () => {
                        this.updateBigElements(section);
                        blogGridWrap.classList.add('activeAnim');
                        ScrollTrigger.refresh();
                        const activeFilter = mixer.getState().activeFilter;
                        if (activeFilter) {
                            if (activeFilter.selector === '.mix') {
                                window.location.hash = '';
                            } else {
                                window.location.hash = activeFilter.selector.replace('.', '');
                            }
                        }
                    },
                },
            });

            this.initGrid(section);
        });
    },

    calculateIndices: function (elements) {
        const indices = [];
        let current = 1;
        let step = 11;

        const visibleElements = Array.from(elements).filter((el) =>
            this.isVisible(el)
        );

        while (current <= visibleElements.length) {
            indices.push(current);
            current += step;
            step = step === 11 ? 7 : 11;
        }

        return indices;
    },

    isVisible: function (element) {
        return element.offsetParent !== null;
    },

    updateFilterFromHash: function () {
        const hash = window.location.hash.substring(1); // Get the hash without the '#'
        const filterButton = document.querySelector(`[data-filter=".${hash}"]`);

        if (filterButton) {
            filterButton.click(); // Simulate a click on the filter button
        }
    },

    initGrid: function (section) {
        if (!section) return;

        this.updateBigElements(section);
        this.updateFilterFromHash(); // Check for hash on initialization
    },

    updateBigElements: function (section) {
        if (!section) return;

        const blogGridWrap = section.querySelector('.blog-grid-wrap');
        const elements = section.querySelectorAll('[data-blog-grid-item-js]');
        const visibleElements = Array.from(elements).filter((el) => this.isVisible(el));
        const indicesToStyle = this.calculateIndices(elements);

        elements.forEach((el) => {
            el.classList.remove('big-el', 'big-el--even', 'big-el--odd');
        });

        visibleElements.forEach((el, index) => {
            if (indicesToStyle.includes(index + 1) && this.isVisible(el)) {
                if ((index + 1) % 2 === 0) {
                    el.classList.add('big-el', 'big-el--even');
                } else {
                    el.classList.add('big-el', 'big-el--odd');
                }
            }
        });

        if (blogGridWrap) {
            blogGridWrap.classList.remove('is-hidden');
        }
    },

};

export default blogGridSection;
